// extracted by mini-css-extract-plugin
export default {"buttonWrap":"style_buttonWrap__Bws2P","prevButton":"style_prevButton__RZgmE","nextButton":"style_nextButton__OhIS7"};